<template>
  <el-dialog
    title="评分规则"
    width="650px"
    custom-class="score-rule-dialog"
    v-bind="commonAttrs"
    :before-close="dialogBeforeClose"
    :append-to-body="true"
    :modal-append-to-body="false"
    v-on="$listeners"
    @open="dialogOpen"
  >
    <div class="rules-wrapper">
      <div v-for="(item, index) in list" :key="index" class="rule-item">
        <div class="item-title">
          {{ item.title }}
        </div>
        <div>
          <ul>
            <li v-for="(rule, index) in item.rules" :key="index">
              {{ rule }}
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div slot="footer" class="score-rule-dialog-footer">
      <el-button type="primary" size="medium" @click="dialogVisible">
        知道了
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    /**
     * 显式指定评分规则维度：hr / td / other。
     * 未传时回退到 vuex candidate 面试阶段（兼容旧项目）。
     */
    ruleStage: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      list: [],
    };
  },
  computed: {
    commonAttrs() {
      return {
        ...this.$attrs,
        ...this.props,
      };
    },
    ...mapState({
      isHRInterviewStage: (state) => (state.candidate && state.candidate.isHRInterviewStage) || false,
      isTDInterviewStage: (state) => (state.candidate && state.candidate.isTDInterviewStage) || false,
      isOtherInterviewStage: (state) =>
        (state.candidate && state.candidate.isOtherInterviewStage) || false,
    }),
  },
  methods: {
    resolveRuleStage() {
      const fromProp = String(this.ruleStage || "").trim().toLowerCase();
      if (fromProp === "hr" || fromProp === "td" || fromProp === "other") {
        return fromProp;
      }
      if (this.isHRInterviewStage) return "hr";
      if (this.isTDInterviewStage) return "td";
      if (this.isOtherInterviewStage) return "other";
      return "other";
    },
    dialogOpen() {
      const dict = {
        hr: [
          {
            title: "简历匹配度（35分）",
            rules: [
              "1.基本情况：包括学历、公司背景、工作时间、年龄、婚育",
              "2.业务匹配度：目标公司、行业方向、业务模式、业务体量、服务客群、相关项目经验",
              "3.专业匹配度：具备的能力、技能点、专业证书、语言等",
              "4.取得成绩：过往业绩、量化数据、主导项目、项目发展状况",
            ],
          },
          {
            title: "逻辑表达（20分）",
            rules: [
              "1.语言表达：能清晰有条理的叙述事情",
              "2.业务逻辑：能够理清业务活动之间的上下左右、内外关系",
              "3.数据逻辑：以数据为基础，呈现各项业务经营数据",
            ],
          },
          {
            title: "责任意识（15分）",
            rules: [
              "1.工作认知：对岗位、工作内容和工作职责有清晰的认知",
              "2.成就感：工作中自主寻求自身的价值和满足",
              "3.乐于奉献：能够优先整体利益保证整体目标的实现，不计较个人得失",
              "4.热爱工作：把工作当成是自己的事业和发展的舞台",
            ],
          },
          {
            title: "求职动机（15分）",
            rules: [
              "1.现实性需要：解决住房、户口迁移、专业对口等)与岗位情况",
              "2.兴趣：个人兴趣爱好与岗位情况",
              "3.成就动机：认知需要、自我提高、自我实现，服务他人的需要，得到锻炼等",
              "4.组织认同：对公司、部门等企业文化的认同",
            ],
          },
          {
            title: "履历稳定性（15分）",
            rules: [
              "1.原工作经历：原工作份数、工作时间；",
              "2.求职意愿：从个人、家庭、性格等方面衡量",
              "3.离职原因：从上家离职、或换工作的原因",
              "4.职业规划：对自身职业生涯、工作职位、技能水平的考虑",
            ],
          },
        ],
        td: [
          {
            title: "技能匹配度（35分）",
            rules: [
              "1.技术匹配：个人所掌握技术与项目组中所用的技术的匹配",
              "2.工作内容：对岗位的岗位职责及项目工作环境的态度",
              "3.人岗匹配：对公司、部门工作模式、工作任务的认可和执行",
            ],
          },
          {
            title: "沟通表达（20分）",
            rules: [
              "1.主动性：沟通意愿强烈，愿意通过沟通来解决问题",
              "2.倾听：愿意主动沟通、认真倾听",
              "3.有效反馈：积极主动理解他人观点且能提供有效反馈",
              "4.语言表达：准确性、简洁性、流畅性 、严密性",
            ],
          },
          {
            title: "解决问题（15分）",
            rules: [
              "1.发现问题：发现影响工作任务不能完成、拖延、停滞而产生的原因",
              "2.分析问题：分析造成影响的原因、产生条件",
              "3.提出方案：提出可行、可实施的解决计划、方案",
              "4.实施检验：实践和改进，把问题推进、处理掉",
            ],
          },
          {
            title: "工作思路（15分）",
            rules: [
              "1.基本情况：任务、活动的时间、地点、内容、方式、主题以及主办、协办单位等应具体明确",
              "2.安排部署：对相关活动、相关工作按阶段或进程做具体的部署安排",
              "3.问题处理：相关问题的处理与解决办法",
            ],
          },
          {
            title: "技术基础（15分）",
            rules: [
              "1.基础技术：完成工作任务所必须掌握的最基础的技术",
              "2.通用技术：为了完成工作任务，要掌握某一行业、某一职业所需的广泛通用型技术",
              "3.专业技术：从事少数专业型岗位所必须掌握的定向、单一等高级专业技术",
            ],
          },
        ],
        other: [
          {
            title: "项目匹配度（35分）",
            rules: [
              "1.技术框架：与项目组中所用的技术框架及要点的匹配程度",
              "2.工作内容：对岗位的岗位职责及项目工作环境的态度",
              "3.项目性质：对项目组工作模式和工作性质的认知。",
              "4.工作强度：对项目组实际工作强度的接受度",
            ],
          },
          {
            title: "职业稳定性（20分）",
            rules: [
              "1.求职动机：员工求职的心理活动",
              "2.岗位认知：对岗位职责、工作技能要求等方面的认知与公司的匹配程度",
              "3.价值观：员工自身价值观与公司、团队现有的价值观的匹配程度",
            ],
          },
          {
            title: "工作态度（15分）",
            rules: [
              "1.负责：党工作任务指派后，能够自驱主动、高效完成",
              "2.汇报：完成上下级、定点数据分析和汇报、结果呈现",
              "3.创新：认真考虑和分析工作流程，更新或新创工作制度、办理办法、实施工具等",
            ],
          },
          {
            title: "团队协作（15分）",
            rules: [
              "1.集体观念：具有集体归属感，重视集体利益",
              "2.信任：对他人持乐观态度，充分信任他人",
              "3.容纳：能理解人之间的差性，愿意与不同风格的人交往",
              "4.理解：关心他人的情绪和状态，并妥善处理好与他人的关系",
            ],
          },
          {
            title: "抗压能力（15分）",
            rules: [
              "1.抗压：在外界压力下处理事务的能力",
              "2.生理：身体遇到压力时所能接受的耐受力、接受度",
              "3.心理：在较大刺激下所能掌握个人情绪、想法、思考等",
            ],
          },
        ],
      };

      const stage = this.resolveRuleStage();
      this.list = dict[stage] || dict.other;
    },
    dialogVisible() {
      this.$emit("update:visible", false);
    },
    dialogBeforeClose() {
      this.$emit("update:visible", false);
    },
  },
};
</script>

<style scoped>
:deep(.el-dialog__body) {
  padding-top: 0px;
  padding-bottom: 0px;
}
.rules-wrapper .rule-item {
  margin-bottom: 8px;
}

.rules-wrapper .rule-item .item-title {
  font-size: 18px;
  margin-bottom: 8px;
}

.rules-wrapper ul {
  list-style: none;
  margin: 0;
  padding-left: 0;
}

.rules-wrapper .rule-item li {
  font-size: 14px;
  line-height: 1.55;
  color: #606266;
}

/* 移动端：与面试评价弹窗一致，85% 宽、居中、约 60vh 高、正文滚动 */
@media (max-width: 768px) {
  ::v-deep .score-rule-dialog {
    width: 85% !important;
    max-width: 85vw;
    margin: 0 !important;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%) !important;
    height: 60vh;
    max-height: 60vh;
    display: flex;
    flex-direction: column;
  }

  ::v-deep .score-rule-dialog .el-dialog__header {
    padding: 12px 12px 6px;
    flex-shrink: 0;
  }

  ::v-deep .score-rule-dialog .el-dialog__title {
    font-size: 16px;
    line-height: 20px;
  }

  ::v-deep .score-rule-dialog .el-dialog__body {
    padding: 6px 10px 6px;
    overflow: auto;
    -webkit-overflow-scrolling: touch;
    flex: 1;
    min-height: 0;
  }

  ::v-deep .score-rule-dialog .el-dialog__footer {
    padding: 8px 10px 10px;
    flex-shrink: 0;
  }

  ::v-deep .score-rule-dialog .score-rule-dialog-footer {
    display: flex;
    justify-content: stretch;
  }

  ::v-deep .score-rule-dialog .score-rule-dialog-footer .el-button {
    flex: 1;
  }

  .rules-wrapper .rule-item {
    margin-bottom: 12px;
  }

  .rules-wrapper .rule-item .item-title {
    font-size: 15px;
    margin-bottom: 6px;
    line-height: 1.4;
  }

  .rules-wrapper .rule-item li {
    font-size: 13px;
    line-height: 1.5;
    margin-bottom: 4px;
  }
}
</style>

